module.exports = __webpack_public_path__ + "static/media/4x6no1.30b0da13.jpg";